import { createContext, useState } from 'react';
import api from 'services/api';

export const PedidosContext = createContext();

export const PedidosProvider = ({ children }) => {
  const [pedidos, setPedidos] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const getPedidos = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: pedidos?.filter,
        page: pedidos?.page,
        size: pedidos?.size,
        order: pedidos?.order,
        ...payload,
      });
      setPedidos((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postImportMarketplace = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Pedidos/Marketplace', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <PedidosContext.Provider
      value={{
        pedidos,
        getLoading,
        getPedidos,
        postLoading,
        postImportMarketplace,
      }}
    >
      {children}
    </PedidosContext.Provider>
  );
};
